module.exports = __webpack_public_path__ + "static/media/0110_IMG_LE_SOL_WOOD_SPIRIT_TEINTE_SPECIALE.c0a5fb61.png";